import React from 'react';
import { TestimonialCard } from '../TestimonialCard';
import styles from './TestimonialsSection.css';

const TESTIMONIALS = [
    {
        author: 'Ruby',
        quote: 'Overall, I really like the idea of making stories out of your memories. I have already completed all of the chapters and ready to share them with my kids. They currently live abroad and I don’t know what would be the next time I see them. But perhaps through my stories we will become more connected in a way.'
    },
    {
        author: 'Paul',
        quote: 'To be honest, I’m not big on technology, but Boundly made it so easy to save my life’s memories without typing a single word. I just talked into my phone like I was chatting with an old friend, sharing stories from my childhood, the old school days, and my college years. I’m gathering my thoughts to record a bunch more memories next week, and I can’t wait until we put it all together into a book. I just want my kids to have something from me so our family stories don’t get lost.'
    },
    {
        author: 'Natalie',
        quote: 'I got this for my mom — and she remembered so many stories from her childhood, her first love, her whole life. We never knew half of it. The whole family is in awe. Best gift we’ve ever given her.'
    }
];

function TestimonialsSection() {
    return (
        <div id='reviews' className={styles.root}>
            <div className={styles.heading}>
                <h3 className={styles.title}>From the people who tried it</h3>
                <p className={styles.subtitle}>See how families are turning memories into stories they’ll keep forever.</p>
            </div>
            <ul className={styles.list}>
                {TESTIMONIALS.map(testimonial => (
                    <TestimonialCard
                        key={testimonial.author}
                        quote={testimonial.quote}
                        author={testimonial.author}
                    />
                ))}
            </ul>
        </div>
    );
}

export {
    TestimonialsSection
};
